import AppLayout from "./layouts/appLayout";
import AuthLayout from "./layouts/authLayout";
import EmptyLayout from "./layouts/emptyLayout";
import NotFoundPage from "./pages/404";
import LoginPage from "./pages/auth/login";
import HomePage from "./pages/dashboard/home";
import RequestsHomePage from "./pages/requests";
import SingleRequestPage from "./pages/requests/singleRequest";
import SettingsHomePage from "./pages/settings";
import UsersHomePage from "./pages/users";
import UsersAddPage from "./pages/users/add";
import UsersEditPage from "./pages/users/edit";
import WalletPage from "./pages/wallet";
import PublicEmptyLayout from "./layouts/publicEmptyLayout";
import ReportsHomePage from "./pages/reports";
import PackagesPage from "./pages/packages";
import GoldiePage from "./pages/users/goldie";
import SinglePage from "./pages/users/single";
import CompleteRequset from "./pages/requests/CompleteRequest";
import InvoiceStatus from "./pages/requests/InvoiceStatus";
import TermsPage from "./pages/terms";
import Profile from "./pages/profile";

const routesConfig = [
    {
        element: <AuthLayout />,
        children: [
            {
                path: "/:lng/login",
                element: <LoginPage />,
            },
        ],
    },
    {
      element: <AppLayout />,
      children: [
        {
          path: "/:lng/",
          element: <HomePage />,
        },
        {
            path: "/",
            element: <HomePage />,
        },
        {
            path: "/:lng/dashboard",
            element: <HomePage />,
        },
        {
          path:'/:lng/workers',
          element: <UsersHomePage />
        },
        {
          path:'/:lng/workers/goldie',
          element: <GoldiePage />
        },
        {
          path:'/:lng/workers/:id',
          element: <SinglePage />
        },
        {
          path:'/:lng/workers/add',
          element: <UsersAddPage />
        },
        {
          path:'/:lng/workers/edit/:id',
          element: <UsersEditPage />
        },
        {
          path:'/:lng/requests',
          element: <RequestsHomePage />
        },
        {
          path:'/:lng/requests/:id',
          element: <SingleRequestPage />
        },
        {
          path: '/:lng/complete-request/:id',
          element: <CompleteRequset />
        },
        {
          path:'/:lng/invoice-status/:id',
          element: <InvoiceStatus />
        },
        {
          path:'/:lng/settings',
          element: <SettingsHomePage />
        },
        {
          path:'/:lng/settings/packages',
          element: <PackagesPage />
        },
        {
          path:'/:lng/wallet',
          element: <WalletPage />
        },
        {
          path:'/:lng/reports',
          element: <ReportsHomePage />
        },
        {
          path:'/:lng/terms-and-conditions',
          element: <TermsPage />
        },
        {
          path:'/:lng/profile',
          element: <Profile />
        }
      ],
    },
    {
      element: <EmptyLayout />,
      children: [
        {
          path: "*",
          element: <NotFoundPage />,
        },
      ],
    },
    {
      element: <PublicEmptyLayout />,
      children: [
        
      ],
    },
  ];

  export default routesConfig;